// Índice de documentos de la categoría: Webchat
import configurar_webchats from './configurar-webchats.js';

const webchatDocs = [
  configurar_webchats,
];

export default webchatDocs;
